import { ccwpApi } from "@/services";

export const ReportsApi=ccwpApi.injectEndpoints({
    endpoints:(builder)=>({
        getReportsList: builder.query<any,Partial<any>>({
            query: (arags) => ({
              url:  "/Report/GetReportsList",
              method: "GET",
              params:{...arags},
            }),
        }),
        getPayeeMatchReport:  builder.query<any,Partial<any>>({
            query: (arags) => ({
              url:  "/Report/GetPayeeMatchReportList",
              method: "GET",
              params:{...arags},
            }),
        }),  
        downloadGenerateDocumentWithOutExport: builder.query({
          query: ({ CaseId, fileName = "downloaded_file",Url,...args }) => ({
            url: Url, 
            method: "GET",
           
            transformResponse: (response:any) => response,

            params: { CaseId ,...args},
            cache: "no-cache",
          }),
        }), 
        downloadGenerateDocument: builder.query({
          query: ({ CaseId, fileName = "downloaded_file",Url,...args }) => ({
            url: Url, 
            method: "GET",
            responseHandler: async (response) => {
              if (response?.status === 400) {
                return Promise.reject(response);
              }
              if(response?.status === 200){
              const url = URL.createObjectURL(await response.blob());
              const a = document.createElement("a");
              a.href = url;
              a.download = fileName;
              const downloadControls =
                document.getElementsByClassName("motif-modal-content")[0] ||
                document.body;
              downloadControls.appendChild(a);
              a.click();
              downloadControls.removeChild(a);
              URL.revokeObjectURL(url);
              }
            },
            transformResponse: (response:any) => response,

            params: { CaseId ,...args},
            cache: "no-cache",
          }),
        }),   
        // downloadDocument: builder.query({
        //     query: (params) => ({
        //       url: `/Document/Download?caseId=${params.CaseId}&documentId=${params.DocumentId}`, 
        //       method: "GET",
        //       responseHandler: async (response) => {
        //         const url = URL.createObjectURL(await response.blob());
        //         const a = document.createElement("a");
        //         a.href = url;
        //         a.download = params.fileName;
        //         const downloadControls =
        //           document.getElementsByClassName("motif-modal-content")[0] ||
        //           document.body;
        //         downloadControls.appendChild(a);
        //         a.click();
        //         downloadControls.removeChild(a);
        //         URL.revokeObjectURL(url);
        //       },
        //       cache: "no-cache",
        //     }),
        //   }),
        
        getPaymentReportList: builder.query<any,Partial<any>>({
          query: (arags) => ({
            url:  "/payment/GetPaymentRegisterReportList",
            method: "GET",
            params:{...arags},
          }),
      }),
          downloadDocumentReport: builder.mutation<any, any>({
            query: (params) => ({
              url: "Document/Download",
              method: "GET",
               responseHandler: async (response: Response) => {
                if (response?.status === 200) {
                  const url = URL.createObjectURL(await response.blob());
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = params?.fileName || "checq_file";
                  const downloadControls =
                    document.getElementsByClassName("motif-modal-content")[0] ||
                    document.body;
                  downloadControls.appendChild(a);
                  a.click();
                  downloadControls.removeChild(a);
                  URL.revokeObjectURL(url);
                }
              },
              params: { CaseId:params.caseId,DocumentId:params.documentId },
              cache: "no-cache",
            }),
          }),
    })
})


export const{useGetReportsListQuery,useLazyDownloadGenerateDocumentWithOutExportQuery,useLazyDownloadGenerateDocumentQuery, useDownloadDocumentReportMutation,useGetPaymentReportListQuery,useGetPayeeMatchReportQuery}=ReportsApi
